'use client';

import Link from 'next/link';
import './akka-link.scss';

function getLinkType(url = '') {
  if (!url) return '';
  if (typeof url !== 'string') return 'internal'; // Handle object URLs as internal
  if (url.startsWith('#')) return 'anchor';
  if (url.startsWith('mailto:')) return 'mailto';
  if (url.startsWith('tel:')) return 'tel';
  if (url.startsWith('http')) return 'external';
  return 'internal';
}

export default function AkkaLink({
  href = undefined,
  children = undefined,
  icon = undefined,
  iconPosition = 'right',
  className = '',
  onClick = undefined,
  ...props
}) {
  // If only onClick is provided, render a button
  if (!href && onClick) {
    return (
      <button type="button" className={`AkkaLink ${className}`} onClick={onClick} {...props}>
        {renderContent(children, icon, iconPosition)}
      </button>
    );
  }

  if (!href) return null;

  const type = getLinkType(href);
  const classes = `AkkaLink ${className}`;

  if (['mailto', 'tel', 'anchor', 'external'].includes(type) || type === 'external') {
    const isExternal = type === 'external';
    const rel = isExternal ? 'external noopener noreferrer' : undefined;
    const target = isExternal ? '_blank' : undefined;

    return (
      <a href={href} className={classes} onClick={onClick} rel={rel} target={target} {...props}>
        {renderContent(children, icon, iconPosition)}
      </a>
    );
  }

  return (
    <Link href={href} className={classes} onClick={onClick} {...props}>
      {renderContent(children, icon, iconPosition)}
    </Link>
  );
}

function renderContent(children, icon, iconPosition) {
  if (!icon) return children;

  return (
    <>
      {iconPosition === 'left' && <span className="AkkaLink__icon">{icon}</span>}
      {children}
      {iconPosition === 'right' && <span className="AkkaLink__icon">{icon}</span>}
    </>
  );
}
